import {
  Flex,
  Heading,
  useColorModeValue,
  Text,
  Image,
} from "@chakra-ui/react";
import React from "react";
import { useNavigate } from "react-router-dom";
import { Booking } from "../../data/occupancy.api";
import placeholderImg from "../../assets/event-placeholder.jpg";
import moment from "moment";

type Props = {
  booking: Booking;
};

const BookingCard = ({ booking }: Props) => {
  const navigate = useNavigate();
  const bg = useColorModeValue("gray.50", "gray.700");
  const hoverColour = useColorModeValue("gray.100", "gray.600");

  return (
    <Flex
      border="1px solid rgba(0, 0, 0, 0.1)"
      rounded="md"
      overflow="hidden"
      role="group"
      bg={bg}
      cursor="pointer"
      transition=".1s all"
      _hover={{ bg: hoverColour }}
      onClick={() => navigate(`/book/my-bookings/${booking.id}`)}
    >
      <Flex p={5} flex={1} gap={3}>
        <Flex direction="column" flex={1}>
          <Heading size="sm">{booking.locationViewModel.name}</Heading>
          <Text fontSize="xs" opacity={0.7}>
            {booking.locationViewModel.buildingName},{" "}
            {booking.locationViewModel.spaceNumber}
          </Text>
          <Text fontSize="xs" opacity={0.5}>
            {moment(booking.startDate).format("DD/MM/YYYY HH:mm")} -{" "}
            {moment(booking.endDate).format("HH:mm")}
          </Text>
        </Flex>
      </Flex>
      <Image
        src={booking.locationViewModel.images?.[0]?.url ?? placeholderImg}
        filter={
          booking.locationViewModel.images?.[0]?.url
            ? undefined
            : "grayscale(100%)"
        }
        alt={`${booking.locationViewModel.name}`}
        objectFit="cover"
        w={24}
      />
    </Flex>
  );
};

export default BookingCard;
